import { Controller } from "@hotwired/stimulus"

// Light client-side half of the intent invariant (self must be in
// acceptable): picking a "You" answer auto-checks it in the "Open to"
// checkbox list. The model validates the invariant strictly on save.
export default class extends Controller {
    connect() {
        this.element.querySelectorAll('input[type="radio"][name$="[self]"]:checked').forEach((radio) => {
            if (radio.value) this.syncSelf({ target: radio })
        })
    }

    syncSelf(event) {
        let value = event.target.value
        if (!value) return
        let box = this.element.querySelector(`input[type="checkbox"][value="${CSS.escape(value)}"]`)
        if (box && !box.checked) {
            box.checked = true
        }
    }
}
